import { FC } from "react";
import { FormattedCategory } from "./CategoryWrapper";
import { styled } from "styled-components";
import { font } from "../lib/sharedStyles";

const Tile = styled.a`
  display: flex;
  flex-direction: column;
  text-decoration: none;

  @media (max-width: 767px) {
    width: 200px;
  }

  span:nth-of-type(1) {
    ${font('Instrument Sans', 600, '14px', '22px')}
    color: #000;
    letter-spacing: 0.14px;
    margin-bottom: 4px;
  }

  span:nth-of-type(2) {
    ${font('Instrument Sans', 400, '12px', '20px')}
    color: #000;
    letter-spacing: 0.12px;
  }
`;

const ImageSquare = styled.div<{$hasHoverImage: boolean;}>`
  position: relative;
  display: flex;
  width: 100%;
  padding-bottom: 100%;
  margin-bottom: 16px;

  ${({ $hasHoverImage }) => $hasHoverImage && `
    &:hover {
      img:nth-of-type(2) {
        opacity: 1;
      }
    }
  `}
`;

const Image = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const HoverImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 300ms ease;
`;

const CategoryTile: FC<FormattedCategory> = ({ url, title, description, imageUrl, hoverImageUrl }) => (
  <Tile href={url}>
    <ImageSquare $hasHoverImage={(hoverImageUrl) ? true : false}>
      {imageUrl && <Image src={imageUrl} />}
      {hoverImageUrl && <HoverImage src={hoverImageUrl} />}
    </ImageSquare>
    <span>{title}</span>
    {description && (
      <span>{description}</span>
    )}
  </Tile>
);

export default CategoryTile;